import { Outlet } from 'react-router-dom'
import MemberBottomNav from '../components/MemberBottomNav'

export default function MemberLayout() {
  return (
    <>
      <Outlet />
      <MemberBottomNav />
    </>
  )
}